import styles from "./Alert.module.css";

import IconCaution from "../icons/IconCaution";
import IconCheckCircle from "../icons/IconCheckCircle";
import IconInfo from "../icons/IconInfo";
import IconError from "../icons/IconError";
import { ReactNode } from "react";

interface AlertProps {
  type?: "success" | "error" | "info" | "warning";
  title?: string;
  message?: string | ReactNode;
  fullWidth?: boolean;
  className?: string;
  icon?: JSX.Element;
  showSupport?: boolean;
  showHelpChat?: () => void;
  dismissable?: boolean;
}

export default function Alert(props: AlertProps) {
  const { type = "success", className = "", icon, title, message, fullWidth, showSupport, showHelpChat, dismissable } = props;

  const Icon =
    type === "success" ? IconCheckCircle : type === "error" ? IconError : type === "info" ? IconInfo : IconCaution;

  let _className: string = styles[type] + ` ${className}`;
  if (fullWidth) {
    _className += " fullWidth";
  }

  const messageNode = message instanceof Object ? message : <p>{message}</p>;

  return (
    <div className={`${styles.container} ${_className}`}>
      {icon ?? <Icon />}
      <div className={styles.content}>
        {title && <h3>{title}</h3>}
        {message && messageNode}
        {showSupport && <div><a onClick={showHelpChat}>contact support</a></div>}
      </div>
    </div>
  );
}
